import { p as promiseResolve, b as bootstrapLazy } from './index-ce1df6b3.js';

/*
 Stencil Client Patch Esm v2.8.0 | MIT Licensed | https://stenciljs.com
 */
var patchEsm = function patchEsm() {
  return promiseResolve();
};
var defineCustomElements = function defineCustomElements(win, options) {
  if (typeof window === 'undefined') return Promise.resolve();
  return patchEsm().then(function () {
    return bootstrapLazy([["deckgo-bar-chart_3", [[1, "deckgo-bar-chart", {
      "width": [1026],
      "height": [1026],
      "src": [1],
      "separator": [1],
      "customLoader": [4, "custom-loader"],
      "marginTop": [2, "margin-top"],
      "marginBottom": [2, "margin-bottom"],
      "marginLeft": [2, "margin-left"],
      "marginRight": [2, "margin-right"],
      "animation": [4],
      "animationDuration": [2, "animation-duration"],
      "data": [16],
      "yAxis": [4, "y-axis"],
      "yAxisMin": [2, "y-axis-min"],
      "updateCurrentBar": [64],
      "draw": [64],
      "next": [64],
      "prev": [64],
      "isBeginning": [64],
      "isEnd": [64],
      "postCustomLoad": [64]
    }], [1, "deckgo-line-chart", {
      "width": [1026],
      "height": [1026],
      "src": [1],
      "separator": [1],
      "customLoader": [4, "custom-loader"],
      "datePattern": [1, "date-pattern"],
      "marginTop": [2, "margin-top"],
      "marginBottom": [2, "margin-bottom"],
      "marginLeft": [2, "margin-left"],
      "marginRight": [2, "margin-right"],
      "yAxisDomain": [1, "y-axis-domain"],
      "smooth": [4],
      "area": [4],
      "ticks": [2],
      "grid": [4],
      "animation": [4],
      "animationDuration": [2, "animation-duration"],
      "draw": [64],
      "next": [64],
      "prev": [64],
      "isBeginning": [64],
      "isEnd": [64],
      "postCustomLoad": [64]
    }], [1, "deckgo-pie-chart", {
      "width": [1026],
      "height": [1026],
      "marginTop": [2, "margin-top"],
      "marginBottom": [2, "margin-bottom"],
      "marginLeft": [2, "margin-left"],
      "marginRight": [2, "margin-right"],
      "innerRadius": [2, "inner-radius"],
      "src": [1],
      "separator": [1],
      "customLoader": [4, "custom-loader"],
      "animation": [4],
      "animationDuration": [2, "animation-duration"],
      "draw": [64],
      "next": [64],
      "prev": [64],
      "isBeginning": [64],
      "isEnd": [64],
      "postCustomLoad": [64]
    }]]]], options);
  });
};
export { defineCustomElements };